'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {TimeAgo} from '../../../components/temporal/TimeAgo';
import {AvatarImage} from '../../../files/components/AvatarImage';
import {Image} from '../../../files/components/Image';

export function ChatImageItemView(props) {
  return (
    <div
      className={classNames("ChatTextItem", props.className, {
        ChatTextItem_sent: props.isAuthor,
      })}
    >
      <AvatarImage
        className="ChatTextItem__initial"
        iconClass="Avatar__largeIcon"
        avatarInitials={props.senderInitial}
        title={props.sender}
        avatarColor={props.avatarColor}
        avatarFontColor={props.avatarFontColor}
        url={props.avatarUrl}
        displayWidth={44}
        displayHeight={44}
        targetWidth={44}
        targetHeight={44}
      />
      <div className="ChatTextItem__timestamp">
        {`${props.sender}, `}
        <TimeAgo date={props.date} />
      </div>
      <div className="ChatTextItem__text">
        <Image
          className="ChatImageItem__image"
          url={props.url}
        />
      </div>
    </div>
  );
}

ChatImageItemView.propTypes = {
  className: T.string,
  isAuthor: T.bool,
  message: T.string,
  date: TimeAgo.propTypes.date,
  sender: T.string,
  senderInitial: T.string,
  avatarColor: T.string,
  avatarFontColor: T.string,
  avatarUrl: T.string,
};

ChatImageItemView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatImageItem/ChatImageItemView.js